module.exports = __webpack_public_path__ + "static/cag2-d91e508ddfc2b1e44d275f2a51f3abd8.png";